import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _HealthIDType, _HealthMedication, _HealthMedicationCatalog, _StructureCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { PharmaStateEditor } from "./PharmaRecordState/PharmaStateEditor";
import { PharmaLaboratoryEditor } from "./PharmaLaboratory/PharmaLaboratoryEditor";
import { PharmaCumStateEditor } from "./PharmaCumState/PharmaCumStateEditor";
import { MeansAdministrationEditor } from "./MeansAdministration/MeansAdministrationEditor";
import { PharmaPresentationEditor } from "./PharmaPresentation/PharmaPresentationEditor";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { FileInput } from "../../../theme/Component/FileInput";



export const HealthMedication = () => {

    const medication = useDataBean(_HealthMedication);
     const imp = useDataBean(_HealthMedicationCatalog);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [activeIngredient, setActiveIngredient ] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
     const [form, setForm] = useState<any>({
        IDPharmaRecordState:null,
        PharmaRecordStateName:null,
        IDPharmaLaboratory:null,
        PharmaLaboratoryName:null,
        IDPharmaCumState:null,
        PharmaCumState:null,
        IDMeansAdministration:null,
        MeansAdministrationName:null,
        IDPharmaPresentation:null,
        PharmaPresentationName:null,
        IDPharmaLaboratoryVendor:null,
        PharmaLaboratoryVendorName:null
     });
     const [modalby, setModalby] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitems, setModalitems] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        medication.instance.getHealthMedicationCatalog(form.IDPharmaLaboratory,form.IDPharmaRecordState,form.IDPharmaCumState,form.IDMeansAdministration,form.IDPharmaPresentation,form.IDPharmaLaboratoryVendor,activeIngredient,regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        medication.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const verby = () => {
    setModalby({ ...modalby, "view": true });
    }
    const deleteItem = () => {
        medication.deleteItemVoid(medication.bean.IDHealthMedication).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
         if (!medication.bean.Record) {
            toast.warning("Debe proporcionar un Expediente.");
            return;
        }
         if (!medication.bean.Name) {
            toast.warning("Debe proporcionar un Nombre.");
            return;
        } 
        if (!medication.bean.IDPharmaLaboratory) {
            toast.warning("Debe proporcionar un  Laboratorio Fabricante.");
            return;
        }
         if (!medication.bean.MedicalRegistration) {
            toast.warning("Debe proporcionar un Registro Sanitario.");
            return;
        }
          if (!medication.bean.IDPharmaRecordState) {
            toast.warning("Debe proporcionar un Estado Registro Médico.");
            return;
        }
          if (!medication.bean.IDPharmaCumState) {
            toast.warning("Debe proporcionar un Estado CUM.");
            return;
        }
        if (!medication.bean.CumQuantity) {
            toast.warning("Debe proporcionar una Cantidad CUM.");
            return;
        }
        if (!medication.bean.ActiveFromDate) {
            toast.warning("Debe proporcionar una Fecha Activo.");
            return;
        }
         if (!medication.bean.MeasurementUnits) {
            toast.warning("Debe proporcionar una Unidad de Medida.");
            return;
        }
        if (!medication.bean.IDMeansAdministration) {
            toast.warning("Debe proporcionar una Vía de Administración.");
            return;
        }
        if (!medication.bean.IDPharmaPresentation) {
            toast.warning("Debe proporcionar una Presentación.");
            return;
        }
        if (!medication.bean.IDPharmaLaboratoryVendor) {
            toast.warning("Debe proporcionar un Laboratorio Representante.");
            return;
        }
        medication.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthMedication', visible: true },
        { title: 'Expediente', property: 'Record', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Laboratorio Fabricante', property: 'PharmaLaboratoryName', visible: true },
        { title: 'Registro Sanitario', property: 'MedicalRegistration', visible: true },
        { title: 'Fecha Expedición', property: 'FromDate', visible: true },
        { title: 'Fecha Vencimiento', property: 'DefeatDate', visible: true },
        { title: 'Estado Registro Médico', property: 'PharmaRecordStateName', visible: true },
        { title: 'Registro CUM', property: 'CumRecord', visible: true },
        { title: 'Consecutivo CUM', property: 'CumConsecutive', visible: true },
        { title: 'Estado CUM', property: 'PharmaCumState', visible: true },
        { title: 'Cantidad CUM', property: 'CumQuantity', visible: true },
        { title: 'Fecha Activo', property: 'ActiveFromDate', visible: true },
        { title: 'Fecha Inactivo', property: 'ActiveUptoDate ', visible: true },
        { title: 'Muestra Médica', property: 'MedicalSample', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnits', visible: true },
        { title: 'ATC', property: 'AtcCode', visible: true },
        { title: 'Descripción ATC', property: 'AtcDescription', visible: true },
        { title: 'Vía de Administración', property: 'MeansAdministrationName', visible: true },
        { title: 'Concentración', property: 'Concentración', visible: true },
        { title: 'Principio Activo', property: 'ActiveIngredient', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Unidad Referencia', property: 'ReferenceUnit', visible: true },
        { title: 'Presentación', property: 'PharmaPresentationName', visible: true },
        { title: 'Laboratorio Representante', property: 'PharmaLaboratoryVendorName', visible: true },
        { title: 'Tipo Role', property: 'PharmaceuticalRolType', visible: true },
        { title: 'Modalidad', property: 'PharmaceuticalModality', visible: true },
        { title: 'IUM', property: 'IUMCode', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${medication.bean.Name}`, "view": true }) } },
            { titulo: 'Items del código', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalitems({ ...modalitems, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
const importHealthMedicationCatalog = () => {
        //console.log(entailment.bean);
        imp.instance.importHealthMedicationCatalog(imp.bean.Media, imp.bean.MediaContext, null).then(
            (resp: any) => {
                // getLista();
                setModalby({ ...modalby, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <BasicPage titulo="Catálogo de Medicamentos">
            <div className="row">
                <div className="col-md-4">
                     <PharmaStateEditor render={form.PharmaRecordStateName} idSelector={form.IDPharmaRecordState} onChange={(e) => { setForm({ ...form, "IDPharmaRecordState": e.IDPharmaRecordState, "PharmaRecordStateName": e.Name }) }}  returnType="Object" />
                </div>
                <div className="col-md-4">
                      <PharmaLaboratoryEditor render={form.PharmaLaboratoryName} idSelector={form.IDPharmaLaboratory} onChange={(e) => { setForm({ ...form, "IDPharmaLaboratory": e.IDPharmaLaboratory, "PharmaLaboratoryName": e.Name }) }}  returnType="Object" />
                </div>
                <div className="col-md-4">
                      <PharmaCumStateEditor render={form.PharmaCumState} idSelector={form.IDPharmaCumState} onChange={(e) => { setForm({ ...form, "IDPharmaCumState": e.IDPharmaCumState, "PharmaCumState": e.Name }) }}  returnType="Object" />
                </div>
                <div className="col-md-4">
                    <MeansAdministrationEditor render={form.MeansAdministrationName} idSelector={form.IDMeansAdministration} onChange={(e) => { setForm({ ...form, "IDMeansAdministration": e.IDMeansAdministration, "MeansAdministrationName": e.Name }) }}  returnType="Object" />
                </div>
                 <div className="col-md-4">
                    <PharmaPresentationEditor render={form.PharmaPresentationName} idSelector={form.IDPharmaPresentation} onChange={(e) => { setForm({ ...form, "IDPharmaPresentation": e.IDPharmaPresentation, "PharmaPresentationName": e.Name }) }}  returnType="Object" />
                </div>
                <div className="col-md-4">
                      <PharmaLaboratoryEditor render={form.PharmaLaboratoryVendorName} idSelector={form.IDPharmaLaboratoryVendor} onChange={(e) => { setForm({ ...form, "IDPharmaLaboratoryVendor": e.IDPharmaLaboratory, "PharmaLaboratoryVendorName": e.Name }) }} label="Laboratorio Representante" returnType="Object" />
                </div>
                 <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="mb-4 form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <label>Pricipio Activo</label>
                    <input type="text" className="mb-4 form-control" value={activeIngredient} onChange={(e) => { setActiveIngredient(e.target.value) }} />
                </div>
                 <BasicButton icon="ri-profile-line" clase="mt-4 btn btn-outline-primary btn-border" eventClick={verby}>
                    Importar Listado de Medicamentos
                </BasicButton>
                 <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={medication.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={medication.bean.Name} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Expediente</label>
                                <input type="text" name="Record" className="form-control" value={medication.bean.Record} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <PharmaLaboratoryEditor render={medication.bean.PharmaLaboratoryName} idSelector={medication.bean.IDPharmaLaboratory} onChange={(e) => { medication.setBean({ ...medication.bean, "IDPharmaLaboratory": e.IDPharmaLaboratory, "PharmaLaboratoryName": e.Name }) }} label="Laboratorio Fabricante" returnType="Object" />
                           </div>
                           <div className="col-md-6">
                                <label>Registro Sanitario</label>
                                <input type="text" name="MedicalRegistration" className="form-control" value={medication.bean.MedicalRegistration} onChange={medication.handleChange} />
                            </div>
                             <div className="col-md-6">
                                <InputDate label="Fecha Expedición" name="" value={medication.bean.FromDate} setDate={(e) => { medication.setBean({ ...medication.bean, 'FromDate': e }) }}  />
                            </div>
                            <div className="col-md-6">
                                <InputDate label="Fecha de Vencimiento" name="" value={medication.bean.DefeatDate} setDate={(e) => { medication.setBean({ ...medication.bean, 'DefeatDate': e }) }}  />
                           </div>
                           <div className="col-md-6">
                               <PharmaStateEditor render={medication.bean.PharmaRecordStateName} idSelector={medication.bean.IDPharmaRecordState} onChange={(e) => { medication.setBean({ ...medication.bean, "IDPharmaRecordState": e.IDPharmaRecordState, "PharmaRecordStateName": e.Name }) }} label="Estado Registro Médico" returnType="Object" />
                           </div>
                           <div className="col-md-6">
                                <label>Registro CUM</label>
                                <input type="text" name="CumRecord" className="form-control" value={medication.bean.CumRecord} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Consecutivo CUM</label>
                                <input type="text" name="CumConsecutive" className="form-control" value={medication.bean.CumConsecutive} onChange={medication.handleChange} />
                            </div>
                           <div className="col-md-6">
                                <PharmaCumStateEditor render={medication.bean.PharmaCumState} idSelector={medication.bean.IDPharmaCumState} onChange={(e) => { medication.setBean({ ...medication.bean, "IDPharmaCumState": e.IDPharmaCumState, "PharmaCumState": e.Name }) }} label='Estado CUM' returnType="Object" />
                           </div>
                           <div className="col-md-6">
                                <label>Cantidad CUM</label>
                                <input type="text" name="CumQuantity" className="form-control" value={medication.bean.CumQuantity} onChange={medication.handleChange} />
                            </div>
                             <div className="col-md-6">
                                <InputDate label="Fecha Activo" name="" value={medication.bean.ActiveFromDate} setDate={(e) => { medication.setBean({ ...medication.bean, 'ActiveFromDate': e }) }}  />
                            </div>
                             <div className="col-md-6">
                                <InputDate label="Fecha Inactivo" name="" value={medication.bean.ActiveUptoDate} setDate={(e) => { medication.setBean({ ...medication.bean, 'ActiveUptoDate': e }) }}  />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={medication.bean.MedicalSample} label="Muestra Médica" eventChange={(e: any) => { medication.setBean({ ...medication.bean, "MedicalSample": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <label>Unidad de Medida</label>
                                <input type="text" name="MeasurementUnits" className="form-control" value={medication.bean.MeasurementUnits} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>ATC</label>
                                <input type="text" name="AtcCode" className="form-control" value={medication.bean.AtcCode} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-12">
                                 <label>Descripción ATC</label>
                                <textarea name="AtcDescription" className="form-control" value={medication.bean.AtcDescription} onChange={medication.handleChange} />
                            </div>
                           <div className="col-md-6">
                                <MeansAdministrationEditor render={medication.bean.MeansAdministrationName} idSelector={medication.bean.IDMeansAdministration} onChange={(e) => { medication.setBean({ ...medication.bean, "IDMeansAdministration": e.IDMeansAdministration, "MeansAdministrationName": e.Name }) }} label="Vía de Administración" returnType="Object" />
                           </div>
                           <div className="col-md-6">
                                <label>Concentración</label>
                                <input type="text" name="Concentration" className="form-control" value={medication.bean.Concentration} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Principio Activo</label>
                                <input type="text" name="ActiveIngredient" className="form-control" value={medication.bean.ActiveIngredient} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Cantidad</label>
                                <input type="text" name="Quantity" className="form-control" value={medication.bean.Quantity} onChange={(e: any) => { medication.setBean({ ...medication.bean, "Quantity": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Unidad Referencia</label>
                                <input type="text" name="ReferenceUnit" className="form-control" value={medication.bean.ReferenceUnit} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <PharmaPresentationEditor render={medication.bean.PharmaPresentationName} idSelector={medication.bean.IDPharmaPresentation} onChange={(e) => { medication.setBean({ ...medication.bean, "IDPharmaPresentation": e.IDPharmaPresentation, "PharmaPresentationName": e.Name }) }} label="Presentación" returnType="Object" />
                           </div>
                           <div className="col-md-6">
                                <PharmaLaboratoryEditor render={medication.bean.PharmaLaboratoryVendorName} idSelector={medication.bean.IDPharmaLaboratoryVendor} onChange={(e) => { medication.setBean({ ...medication.bean, "IDPharmaLaboratoryVendor": e.IDPharmaLaboratory, "PharmaLaboratoryVendorName": e.Name }) }} label="Laboratorio Representante" returnType="Object" />
                           </div>
                           <div className="col-md-6">
                                <label>Tipo Role</label>
                                <input type="text" name="PharmaceuticalRolType" className="form-control" value={medication.bean.PharmaceuticalRolType} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Modalidad</label>
                                <input type="text" name="PharmaceuticalModality" className="form-control" value={medication.bean.PharmaceuticalModality} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>IUM</label>
                                <input type="text" name="IUMCode" className="form-control" value={medication.bean.IUMCode} onChange={medication.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={medication.bean.Description} onChange={medication.handleChange} />
                            </div>
                        </div>
                    </Modal>
                      <Modal modal={modalby} updateModal={setModalby} eventModal={importHealthMedicationCatalog}>
                        <div className="row">
                          <div className="col-md-12">
                             <FileInput
                                Media={imp.bean.Media}
                                MediaContext={imp.bean.MediaContext}
                                directory='transporte'
                                label='Archivo'
                                onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                            ></FileInput>
                          </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {medication.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}